import { ActionSheet, List, ListItemProps } from 'antd-mobile';
import { Action } from 'antd-mobile/es/components/action-sheet';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MdExitToApp } from 'react-icons/md';
import { TfiKey } from 'react-icons/tfi';
import { VscGlobe } from 'react-icons/vsc';
import { container } from 'tsyringe';

import { LanguageType } from '@/v1/main/domain/config';
import { AuthServiceImpl } from '@/v1/main/usecases';
import { ChangePasswordForm } from '@/v1/main/views/Form';
import { HeaderImage, HeaderType } from '@/v1/main/views/Image';
// import { BiSun, BiMoon } from 'react-icons/bi';
import {
    ModalOption,
    ModalType,
    useAuth,
    useLanguage,
    useModal,
} from '@/v1/main/views/Provider';

import styles from './Setting.module.scss';

export const Setting = () => {
    const { t } = useTranslation(['interface', 'config']);
    const usecase = container.resolve(AuthServiceImpl);
    const { setModalOption, destroy } = useModal();
    const { language, changeLanguage } = useLanguage();

    const { nickname, setLoggedIn } = useAuth();
    const [changeLang, setChangeLang] = useState<boolean>(false);
    const [changePassword, setChangePassword] = useState<boolean>(false);

    const onLogout = () => {
        const onOk = () => {
            setLoggedIn(false);
            destroy();
        };
        const onCancel = () => {
            destroy();
        };
        const opt: ModalOption = {
            type: ModalType.WARNING,
            title: t('notification.logout.title', { ns: 'interface' }),
            onOk,
            onCancel,
        };
        setModalOption(opt);
    };

    const onChangeLanguage = () => {
        setChangeLang(true);
    };

    const onChangePassword = () => {
        setChangePassword(true);
    };

    const onClose = () => {
        setChangePassword(false);
        setChangeLang(false);
    };

    const languageItems: Action[] = Object.values(LanguageType).map(
        (value: LanguageType) => {
            const onClick = () => {
                changeLanguage(value);
                onClose();
            };
            return {
                key: value,
                text: t(`language.${value}`, { ns: 'config' }),
                onClick,
            };
        }
    );

    const items: ListItemProps[] = [
        {
            title: t(`language.${language}`, { ns: 'config' }),
            prefix: <VscGlobe />,
            onClick: onChangeLanguage,
        },
        {
            title: t('action.change_password', { ns: 'interface' }),
            prefix: <TfiKey />,
            onClick: onChangePassword,
        },
        {
            title: t('action.logout', { ns: 'interface' }),
            prefix: <MdExitToApp />,
            onClick: onLogout,
        },
    ];

    return (
        <div className={styles.wrapper}>
            <List
                header={
                    <HeaderImage type={HeaderType.SETTING} value={nickname} />
                }
            >
                {items.map((reset, index) => (
                    <List.Item
                        className={styles.item}
                        key={index}
                        {...reset}
                    ></List.Item>
                ))}
            </List>
            <ActionSheet
                visible={changeLang}
                actions={languageItems}
                onClose={onClose}
            ></ActionSheet>
            <ChangePasswordForm
                open={changePassword}
                onClose={onClose}
                usecase={usecase}
            />
        </div>
    );
};
